export default {
  type: 'new_users',
  name: 'New Users',
  description: 'New users registered within date range',
  search: {
    search: 'allPeople',
    orderBy: {
      type: 'PeopleOrderBy',
      default: 'CREATION_TIME_DESC'
    },
    fields: [
      { name: 'personId', searchable: false },
      { name: 'fullName', label: 'Name', searchable: false },
      { name: 'username', searchable: false },
      { name: 'email', searchable: false },
      {
        name: 'creationTime',
        type: 'daterange',
        default: { start: 'SOM' },
        searchable: true
      },
      { name: 'affiliation', searchable: false },
      { name: 'accessStatement', searchable: false },
      { name: 'scienceUser', type: 'boolean', searchable: false }
    ]
  }
}
